export const PolicyGroups = {
    SGT: ["SGT_Unit_Spaces" /* PolicyActions.SGT_UNIT_SPACES */, "SGT_Access_Devices" /* PolicyActions.SGT_ACCESS_DEVICES */, "SGT_Schedule" /* PolicyActions.SGT_SCHEDULE */],
    ANALYTICS: [
        "analytics_read" /* PolicyActions.ANALYTICS_READ */,
        "Analytics_Most_Viewed" /* PolicyActions.ANALYTICS_MOST_VIEWED */,
        "Analytics_Last_Viewed" /* PolicyActions.ANALYTICS_LEAST_VIEWED */,
        "Analytics_View" /* PolicyActions.ANALYTICS_SPACES_VIEW */,
        "Analytics_Spaces_View_By_Source" /* PolicyActions.ANALYTICS_SPACES_VIEW_BY_SOURCE */,
        "Analytics_Spaces_View_By_Referral" /* PolicyActions.ANALYTICS_SPACES_VIEW_BY_REFERRAL */,
        "Analytics_Community_Table" /* PolicyActions.ANALYTICS_COMMUNITY_TABLE */,
    ],
    PROSPECT_INTELLIGENCE: [
        "prospect_intelligence_read" /* PolicyActions.PROSPECT_INTELLIGENCE_READ */,
        "Prospect_Intelligence_Activity_Details" /* PolicyActions.PROSPECT_INTELLIGENCE_ACTIVITY_DETAILS */,
        "Prospect_Intelligence_Most_Engaged" /* PolicyActions.PROSPECT_INTELLIGENCE_MOST_ENGAGED */,
        "Prospect_Intelligence_Recent_Activity" /* PolicyActions.PROSPECT_INTELLIGENCE_RECENT_ACTIVITY */,
        "Prospect_Intelligence_Appointments" /* PolicyActions.PROSPECT_INTELLIGENCE_APPOINTMENTS */,
        "Prospect_Intelligence_New_Prospects" /* PolicyActions.PROSPECT_INTELLIGENCE_NEW_PROSPECTS */,
    ],
    SCAN_REQUEST: ["scan_request_create" /* PolicyActions.SCAN_REQUEST_CREATE */, "scan_request_edit" /* PolicyActions.SCAN_REQUEST_EDIT */, "scan_request_read" /* PolicyActions.SCAN_REQUEST_READ */],
    FEATURE_GATING: [],
    INSIGHTS: ["insights_access" /* PolicyActions.INSIGHTS_ACCESS */],
    ACCOUNT_HEALTH: ["account_health_read" /* PolicyActions.ACCOUNT_HEALTH_READ */],
};
